import { Button, Col, Row } from 'antd'
import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'

import 'antd/dist/antd.css'
import './css/landing-page.css'
import { Link } from 'react-router-dom'

const LogoutButton = () => {
  const { logout } = useAuth0()

  return (
    <Button type='primary' shape='round' onClick={() => logout({ returnTo: window.location.origin })}>
      Log Out
    </Button>
  )
}

const ManagerButton = () => {
  const { loginWithRedirect } = useAuth0()
  return <Button type='primary' className='launcher' shape='round' onClick={() => loginWithRedirect({ redirectUri: `${window.location.origin}/manager`, appState: { returnTo: '/manager' } })}>Launch Tournament Manager</Button>
}

const TournamentResultsButton = () => {
  return (
    <Link to='/results'>
      <Button type='primary' className='launcher' shape='round'>
        Previous Tournament Results
      </Button>
    </Link>
  )
}

const LandingPage = () => {
  const { isAuthenticated } = useAuth0()

  return (
    <div className='landing-page background'>
      <div className='title-container'>
        <Row>
          <Col span={24} className='title'>Tournament Manager</Col>
        </Row>
        <Row>
          <Col span={12}>
            <ManagerButton />
          </Col>
          <Col span={12}>
            <TournamentResultsButton />
          </Col>
        </Row>
      </div>
      <div className='logout'>
        {isAuthenticated ? <LogoutButton /> : ''}
      </div>
    </div>
  )
}

export default LandingPage
